import React, { Component } from 'react';
import styles from './styles.scss';
import qs from "query-string";
import WJSON from '../../helpers/json';
class CreditView extends Component 
{
  constructor(props){
    super(props);

    let item = {}

    let query = qs.parse(props.location.search);
    
    if (query.item)
    {
      item = WJSON.decode(query.item)
    }

    this.state = { item : item };

  }
  componentDidMount(){

  }
  render()
  {

    return (
      <div className={styles.page_container}>
        <div className={styles.padding_container}>
          <div className={styles.title_area}>

            <div className={styles.page_title}>
            卡片號碼：{this.state.item.CARDNO}
            </div>
            <div className={styles.date}>{this.state.item.CR_DT}</div>
          </div>
          <div className={styles.content_area}>
            <div className={styles.text_item}>
              <span className={styles.label}>狀態：</span>
              <div className={styles.text}>{this.state.item.TRANSTYPE_NAME}</div>
            </div>
            <div className={styles.text_item}>
              <span className={styles.label}>原有點數：</span>
              <div className={styles.text}>{this.state.item.ORIGINAL_POINT}點</div>
            </div>
            <div className={styles.text_item}>
            <span className={styles.label}>點數：</span>
              <div className={styles.text}>{this.state.item.POINT}點</div>
            </div>
            <div className={styles.text_item}>
              <span className={styles.label}>剩餘點數：</span>
              <div className={styles.text}>{this.state.item.REMAIN_POINT} 點</div>
            </div>
            <div className={styles.text_item}>
              <span className={styles.label}>說明：</span>
              <div className={styles.text}>{this.state.item.SOURCENOTE}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreditView;


// WEBPACK FOOTER //
// ./src/views/Credit/CreditView.js